import Animal from '@/models/Animal'

// https://vuex.vuejs.org/en/actions.html
export const calculaExigencias = ({ commit, state }) => {
  return new Promise((resolve) => {
    state.app.animal_ = new Animal(state, state.app.animal)
    const exigenciasInstance = state.app.animal_.exigencias
    exigenciasInstance.useFormat = false
    exigenciasInstance.calcCMS()
    exigenciasInstance.calcEnergias()
    exigenciasInstance.calcProteinas()
    exigenciasInstance.calcMinerais()
    let exigencias = exigenciasInstance.getData()
    Object.keys(exigencias).forEach((el) => {
      exigenciasInstance[el].minimo_calc = typeof exigenciasInstance[el].minimo === 'string' ? 0 : exigenciasInstance[el].minimo
      exigenciasInstance[el].ideal_calc = typeof exigenciasInstance[el].ideal === 'string' ? 0 : exigenciasInstance[el].ideal
      exigenciasInstance[el].maximo_calc = typeof exigenciasInstance[el].maximo === 'string' ? 0 : exigenciasInstance[el].maximo
      exigenciasInstance[el].changed = false
      if (exigencias[el].childs) {
        Object.keys(exigencias[el].childs).forEach((elchild) => {
          var childs = exigenciasInstance[el].childs[elchild]
          childs.minimo_raw = typeof childs.minimo === 'string' ? 0 : childs.minimo
          childs.ideal_raw = typeof childs.ideal === 'string' ? 0 : childs.ideal
          childs.maximo_raw = typeof childs.maximo === 'string' ? 0 : childs.maximo
        })
      }
    })
    exigenciasInstance.useFormat = true
    exigencias = exigenciasInstance.getData()
    commit('setExigencias', exigencias)
    resolve()
  })
}
